import { AiCadFiles } from './ai-cad-files.model';

export interface AiCadLaunchContext {
    readonly treatmentId: string;
    readonly treatmentTypeOriginalId?: number | null;
    readonly archType?: number | null;
    readonly designId: number;
    readonly jobId?: string | null;
    readonly patientName?: string | null;
    readonly orderNumber?: string | null;
    readonly toothNumber?: string | null;
    readonly toothLabel?: string | null;
    readonly subType?: string | null;
    readonly notes?: string | null;
    readonly expiresAt: string;
    readonly files: AiCadFiles;
}
